import { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const useRaffleDraw = (raffleKey) => {
  const [ready, setReady] = useState(false);
  const [drawTime, setDrawTime] = useState();
  const [drawHash, setDrawHash] = useState();
  const [winners, setWinners] = useState([]);

  const [state, setState] = useState({});

  const get = useCallback(async () => {
    try {
      const res = await axios.get(`/api/raffles/${raffleKey}/draw`);

      const { drawTime, drawHash, winners } = res.data;
      setDrawTime(drawTime);
      setDrawHash(drawHash);
      setWinners(winners);
    } catch (e) {
      // raffle draw not initialized
    }
  }, [raffleKey]);

  const post = useCallback(async () => {
    if (drawHash) return;
    try {
      const res = await axios.post(`/api/raffles/${raffleKey}/draw`);
      const { draw } = res.data;
      if (draw) {
        await get();
      }
    } catch (e) {
      // raffle draw not initialized
    }
  }, [drawHash, raffleKey, get]);

  useEffect(() => {
    setReady(false);
    get().then(() => setReady(true));
  }, [get]);

  useEffect(() => {
    setState({ drawTime, drawHash, winners });
  }, [drawTime, drawHash, winners]);

  const raffleDraw = useMemo(
    () => ({ ready, state, get, post }),
    [ready, state, get, post]
  );

  return raffleDraw;
};

export default useRaffleDraw;
